import React, { useEffect, useState } from "react";
import { Button, Col, Container, Form, Nav, Row, Tab } from "react-bootstrap";
import { Link } from "react-router-dom";
import { CstmPagination } from "../../../../components/Common/Common";

// img
import user from "../../../../Assets/images/user.png";
import { toast } from "react-toastify";
import { GET_BOOKING_REQUESTS } from "../../../../services/ApiCalls";
import Table from "../../../../components/Common/Table";
import CustomPagination from "../../../../components/Common/CustomPagination";
import TableProfile from "../../../../components/Common/TableProfile";

const BookingRequest = () => {
  const [tab, setTab] = useState("normal");
  const [body, setBody] = useState({
    page: 1,
    limit: 10,
    orderBy: "createdAt",
    order: -1,
    search: "",
    status: "all",
    bookingTypeRequest: 'normal'
  });

  const [loader, setLoader] = useState();

  const [data, setData] = useState([]);

  const [totalCount, setTotalCount] = useState(0);

  const getData = async (body) => {
    setLoader(true);
    try {
      const res = await GET_BOOKING_REQUESTS(body);
      if (res?.data?.status === "success") {
        setData(res?.data?.data);
        setLoader(false);

        setTotalCount(res?.data?.totalcount);
      } else {
        setLoader(false);

        toast.error(res?.data?.message);
      }
    } catch (error) {
      setLoader(false);

      toast.error("something went wrong");
    }
  };

  const pageChangeHandler = (page) => {
    const newBody = {
      ...body,
      page,
      bookingTypeRequest: tab,
    };
    setBody((p) => newBody);
    getData(newBody);
  };

  useEffect(() => {
    const newBody = {
      ...body,
      page: 1,
      bookingTypeRequest: tab,
    };

    setBody(newBody);
    getData(newBody);
  }, [tab]);

  const col = [
    {
      label: "Sr no",
      id: "srNo",
      isComponent: true,
      component: (_, key) => (
        <p className={` m-0`}>{(body.page - 1) * body.limit + (key + 1)}</p>
      ),
    },
    {
      label: "User Name",
      isComponent: true,
      component: (item, key) => (
        // <TableProfile url={item.customerImage} name={item.customerName} />
        <TableProfile
          url={item.customerImage}
          name={item?.customerDetails?.name}
        />
      ),
    },
    {
      label: "Booking Id",
      id: "bookingNumber",
    },

    {
      label: "Mobile No",
      id: "bookingNumber",
      isComponent: true,
      component: (item) => (
        <p className="">
          {/* {item.providerCountryCode + item.providerMobileNumber} */}
          {item?.customerDetails?.countryCode +
            item?.customerDetails?.mobileNumber}
        </p>
      ),
    },
    {
      label: "location",
      id: "location",
      isComponent: true,
      component: (item) => <p className="fw-sbold">{item?.pickUp?.address}</p>,
    },
    {
      label: "Vehicle Type",
      id: "serviceType",
      classNames: "text-primary fw-sbold",
    },
    {
      label: "Vehicle Name",
      id: "vehicle",
      isComponent: true,
      component: (item) => <p className="fw-sbold">{item?.services}</p>,
    },
    // {
    //   label: "Status",
    //   id: "status",
    //   isComponent: true,
    //   component: (item) => (
    //     <p
    //       className={`fw-sbold  ${
    //         item.status === "rejected"
    //           ? "text-danger"
    //           : item.status === "confirmed"
    //           ? "text-success"
    //           : "text-primary"
    //       }`}
    //     >
    //       {item.status}
    //     </p>
    //   ),
    // },
    {
      label: "View",
      isComponent: true,
      component: (item) => {
        return (
          <Link
            to={`/booking-request/detail/${item._id}`}
            className="fw-sbold d-inline-flex align-items-center justify-content-center commonBtn btn h-auto text-white"
          >
            Details
          </Link>
        );
      },
    },
  ];
  return (
    <>
      <section className="bookingRequest py-5 position-relative">
        <Container>
          <Row>
            <Col lg="12" className="my-2">
              <Tab.Container
                id="left-tabs-example"
                defaultActiveKey="normal"
                onSelect={(e) => setTab(e)}
              >
                <Nav
                  variant="pills"
                  className="underlineTab border-bottom justify-content-center mb-3"
                  style={{ maxWidth: "max-content" }}
                >
                  <Nav.Item style={{ minWidth: 150 }}>
                    <Nav.Link
                      eventKey="normal"
                      className="bg-transparent position-relative fw-sbold text-center"
                    >
                      Standard
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item style={{ minWidth: 150 }}>
                    <Nav.Link
                      eventKey="bidding"
                      className="bg-transparent position-relative fw-sbold text-center"
                    >
                      Bidding
                    </Nav.Link>
                  </Nav.Item>
                </Nav>
                <div className="table-responsive">
                  <Table data={data} column={col} loader={loader} />
                  <div className="d-flex align-items-center justify-content-end mt-2">
                    <div className="right">
                      <CustomPagination
                        total={totalCount}
                        pageSize={body.limit}
                        current={body.page}
                        pageChangeHandler={pageChangeHandler}
                      />
                    </div>
                  </div>
                </div>
              </Tab.Container>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default BookingRequest;
